import error from "assets/img/error.svg";
import success from "assets/img/success.svg";
import React from "react";
import {Redirect} from 'react-router-dom';
import {useStakingContract, useStakingDispatch} from "../../context/StakingContract";
import {SET_ERROR} from "../../context/StakingContract/actions";

const Success = ({txHash}) => (
  <div className="">
    <img
      src={success}
      className="status my-2"
      alt="Success"
    />
    <h3 className="mb-4">Transaction Sent</h3>
    <p className="mx-5 mb-4">Please check Etherscan to see if the transaction was successful.</p>
    <p><a href={"https://etherscan.io/tx/" + txHash} target="_blank" rel="noopener noreferrer">{txHash}</a></p>
  </div>
);

const Faliure = ({startOver, errorMessage}) => (
  <div className="">
    <img
      src={error}
      className="status my-2"
      alt="Error"
    />
    <h3 className="mb-4">Error</h3>
    <p>The process has encountered an error and needs to be started over.</p>
    <p className="mx-5 mb-4">{errorMessage}</p>
    <button className="btn btn-primary" onClick={startOver}>Start Over</button>
  </div>
);

const Outcome = ({goToStep}) => {
  const {state} = useStakingContract();
  const dispatch = useStakingDispatch();
  const success = !state.error.isError;
  const {staking} = state;

  const [goHome, setGoHome] = React.useState(false);

  const startOver = () => {
    dispatch({type: SET_ERROR, payload: false});
    setGoHome(true);
  };

  if (goHome) {
    return <Redirect to='/'/>;
  }

  return (
    <div className="card">
      <div className="card-body text-center">
        {success ? <Success txHash={staking.stakeTxHash}/> : <Faliure startOver={startOver} errorMessage={state.error.errorMessage}/>}
      </div>
    </div>
  );
};

export default Outcome;
